import {forwardRef, Inject, Injectable} from '@angular/core';
import {HttpAuthService} from '../../shared/service/http-auth.service';
import {Http, RequestMethod, RequestOptionsArgs, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ChangePasswordParamsModel} from '../models/change-password-params.model';
import {handleHttpAuthServiceResp, Utilities} from '../../shared/utilities/utilities.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import { HTTPStatusCode } from '@shared/models/http-status-code.model';
import { ErrorResponse } from '@shared/models/error-response.model';

@Injectable()
export class ChangePasswordService {

	env: AppConfigEnvironment;
	userauth_api_user_password: string;
	oam_base_url: string;

	constructor(
		@Inject(forwardRef(() => HttpAuthService)) public httpAuthService: HttpAuthService,
		private appConfig: AppConfigEnvironmentService,
		private http: Http,
	) {
		this.env = appConfig.Environment;
		this.userauth_api_user_password = this.env.USERAUTH_API + '/user/password';
		this.oam_base_url = this.env.EXTERNAL_API_LEASEPLAN_PSWDMANAGEMENT;
	}

	getChangePasswordParams(): Observable<ChangePasswordParamsModel> {
		return new Observable(
			(observer) => {
				this.httpAuthService.get(this.userauth_api_user_password, this.env.ROOT_REDIRECT, Utilities.setRequestOptionAUTH()).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							observer.next(new ChangePasswordParamsModel(response.json()));
						} else {
							observer.next(null);
						}
					},
					error => {
						console.error(null);
					});
			});
	}

	setPassword(newPassword: string): Observable<Response> {
		const options = Utilities.setRequestOptionAUTH();
		options.method = RequestMethod.Post;
		options.headers.set('Content-Type', 'application/json');
		const body = { password: newPassword };

		return new Observable(
			(observer) => {
				this.httpAuthService.post(this.userauth_api_user_password, body, this.env.ROOT_REDIRECT, options).subscribe(
				response => {
					observer.next(response);
				},
				error => {
					observer.next(error);
				})
			});
	}

	// TODO
	// DA CAMBIARE SU user-detail.component.ts

	resetPassword(username: string): Observable<Response> {
		const url: string = this.env.PERMISSION_API + '/users/reset-password';
		const options = Utilities.setRequestOptionAUTH();
		options.method = RequestMethod.Post;
		options.headers.set('Content-Type', 'application/json');
		const body = {
			account: username
		};

		return this.httpAuthService.post(url, body, this.env.ROOT_REDIRECT, options);
	}

	private getHttpOptionsOAM(user: string, currentPassword: string): RequestOptionsArgs {

		const options = Utilities.setRequestOptionAUTH();
		options.method = RequestMethod.Post;
		options.headers.set('Content-Type', 'application/json');
		options.headers.set('Authorization', 'Basic ' + btoa(user + ':' + currentPassword));
		options.headers.set('x-ALD-subscription-key', this.env.ALD_SUBSCRIPTION_KEY);

		return options;
	}
	
	checkNewPasswordOAM(user: string, currentPassword: string, newPassword: string): Observable<ResponseValidatePassword | ErrorResponse> {

		if (Utilities.isEmpty(user) || Utilities.isEmpty(currentPassword) || Utilities.isEmpty(newPassword)) {
			return;
		}

		// const url = this.oam_base_url + '/PasswordValidateRequests/geutadmin_ssg';
		const url = this.oam_base_url + '/PasswordValidateRequests/' + user;
		const options = this.getHttpOptionsOAM(user, currentPassword);
		const body = { 
			password: newPassword, 
			username: {
					dn			 : 'cn=' + user + ',cn=users,dc=emea,dc=leaseplancorp,dc=net',
					idstore	 : 'OID',
					username : user,
			}
		};

		return new Observable<any>(
			observer => {
					// Evitare httpAuthService perché sovrascrive l'Authorization con il Bearer token
					this.http.post(url, body, options).subscribe(
						res => {
							const content = res.json();
							if (res.status === HTTPStatusCode[200]) {
								try {
									// observer.next(new ResponseValidatePassword(content));
									
									// TODO
									// gestire meglio la risposta
									// mandare in errore sia i casi di 4XX e 5XX, sia quando isValid = false
									
									const obj = new ResponseValidatePassword(content);
		
									if (obj.isValid) {
										observer.next(obj);
										return;
									}
		
									// {"isValid":false,"messages":[{"displayValue":"Password must be at least 14 character(s) long.","placeHolderValueStrings":["14"],"resourceBundleKey":"IAM-3053056"},{"displayValue":"Password must not contain the following string(s): ease , plan ,.","placeHolderValueStrings":["ease , plan ,"],"resourceBundleKey":"IAM3053043"},{"displayValue":"Password must not be a dictionary word.","placeHolderValueStrings":[],"resourceBundleKey":"IAM-3053063"}]}
									observer.error(obj);
		
								} catch (err) {
									console.error(err);
									observer.error(err);
								}
							} else {
								const err = new ErrorResponse(res);
								
								if (err.hasStatusCode([HTTPStatusCode[404], HTTPStatusCode[500]])) {
									console.error(err);
									observer.error(err);
								}	
								
								observer.next(null);
							}
						},
						error => {
							observer.error(new ErrorResponse(error));
						}
					);
			}
		);
	}

	setStatusChangeOAM(user: string, currentPassword: string): Observable<Response> {

		// Porre l'utenza nello stato di cambio - chiedere a Lorenzo cosa significa

		if (Utilities.isEmpty(user) || Utilities.isEmpty(currentPassword)) {
			return;
		}

		const url = this.oam_base_url + '/UserStatusChanger/' + user;
		const options = this.getHttpOptionsOAM(user, currentPassword);
		const body = { forcepwdchange: true };

		return new Observable<any>(
			observer => {
				this.http.post(url, body, options).subscribe(...handleHttpAuthServiceResp(observer));
			}
		);
	}

	setPasswordOAM(user: string, currentPassword: string, newPassword: string): Observable<ResponseValidatePassword | ErrorResponse> {
		
		if (Utilities.isEmpty(user) || Utilities.isEmpty(currentPassword) || Utilities.isEmpty(newPassword)) {
			return;
		}

		const url = this.oam_base_url + '/PasswordResetRequests/' + user;
		const options = this.getHttpOptionsOAM(user, currentPassword);
		const body = { 
			currentPassword: currentPassword, 
			newPassword    : newPassword, 
		};

		return new Observable<ResponseValidatePassword | ErrorResponse>(
			observer => {
					// Evitare httpAuthService perché sovrascrive l'Authorization con il Bearer token
					this.http.post(url, body, options).subscribe(
						res => {
							const content = res.json();
							if (res.status === HTTPStatusCode[200]) {
								try {
									// observer.next(new ResponseValidatePassword(content));
									
									// TODO
									// gestire meglio la risposta
									// mandare in errore sia i casi di 4XX e 5XX, sia quando isValid = false
									
									const obj = new ResponseValidatePassword(content);
		
									if (obj.isValid) {
										observer.next(obj);
										return;
									}
		
									// {"isValid":false,"messages":[{"displayValue":"Password must be at least 14 character(s) long.","placeHolderValueStrings":["14"],"resourceBundleKey":"IAM-3053056"},{"displayValue":"Password must not contain the following string(s): ease , plan ,.","placeHolderValueStrings":["ease , plan ,"],"resourceBundleKey":"IAM3053043"},{"displayValue":"Password must not be a dictionary word.","placeHolderValueStrings":[],"resourceBundleKey":"IAM-3053063"}]}
									observer.error(obj);
		
								} catch (err) {
									console.error(err);
									observer.error(err);
								}
							} else {
		
								const err = new ErrorResponse(res);
		
								if (err.hasStatusCode([HTTPStatusCode[404], HTTPStatusCode[500]])) {
									console.error(err);
									observer.error(err);
								}	
								
								observer.next(null);
							}
						},
						error => {
							observer.error(new ErrorResponse(error));
						}
					);
			}
		);
	}
}

export class ResponseValidatePassword {

	isValid   : boolean = false;
	messages? : {
		displayValue						: string,
		placeHolderValueStrings : string[],
		resourceBundleKey				: string,
	}[];

	constructor(model?: any) {

		if (Utilities.isEmpty(model)) {
			return;
		}

		Object.assign(this, model);
	}
}
